<template>
  <button
    :aria-label="isMuted ? 'Unmute' : 'Mute'"
    class="controls-mute"
    @click.prevent="toggleMute"
  >
    <IconUnmute v-if="isMuted" />
    <IconMute v-else />
  </button>
</template>

<script>
import IconMute from '../assets/svg/mute-legacy.svg'
import IconUnmute from '../assets/svg/unmute-legacy.svg'

export default {
  components: {
    IconMute,
    IconUnmute
  },
  props: {
    store: {
      type: Object,
      default: function () {}
    }
  },
  computed: {
    isMuted () {
      return this.store.state.isMuted
    }
  },
  methods: {
    toggleMute () {
      this.store.setMute(!this.store.state.isMuted)
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'node_modules/simplecast-styles/src/assets/styles/_core/colors.scss';

button {
  background: none;
  border: none;
  padding: 0;
}
svg {
  fill: $black-trans-800;
  height: 100%;
  width: 100%
}
</style>
